export default "__VITE_ASSET__f0378d77__"